import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import storage from "redux-persist/lib/storage";
import {
  signup,
  signin,
  auth,
  user,
  partner,
  home,
  schedule,
  sales,
  notifications,
  centerSettings,
  qna,
  link,
  bshop,
  common,
} from "../slices";

const schedulePersistConfig = {
  key: "schedule",
  version: 1,
  storage: storageSession,
  blacklist: ["scheduleInfo", "scheduleList"],
};

const salesPersistConfig = {
  key: "sales",
  version: 1,
  storage: storageSession,
  whitelist: [
    "searchPartner",
    "searchBranch",
    "searchDate",
    "searchPeriodType",
  ],
};

const userPersistConfig = {
  key: "user",
  version: 1,
  storage,
};

const appReducers = combineReducers({
  common,
  signup,
  signin,
  auth,
  user: persistReducer(userPersistConfig, user),
  partner,
  home,
  schedule: persistReducer(schedulePersistConfig, schedule),
  sales: persistReducer(salesPersistConfig, sales),
  notifications,
  centerSettings,
  qna,
  link,
  bshop,
});

const rootReducer = (state, action) => {
  if (action.type === "user/resetReduxState") state = undefined;
  return appReducers(state, action);
};

export default rootReducer;
